import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { resetTableColors } from "../resetTableColors";
import {
  ALIAS_IDX,
  DATA_PRODUCER_TABLE_NAME,
  ISIN_IDX,
  LAST_ASK_TIMESTAMP_COLUMN,
  NAME_IDX,
  QUOTE_FEED_IDX,
  ROW_ID_COLUMN,
  ROW_ID_IDX,
} from "./constants";
import { protectDataProducerSheet } from "./lockEditModeInSomeColumns";

export async function createDataProducerTable(context: Excel.RequestContext) {
  const currentWorksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);

  let table = currentWorksheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);
  await context.sync();

  if (!table.isNullObject) return;

  currentWorksheet.protection.unprotect();

  table = currentWorksheet.tables.add(ROW_ID_COLUMN + "1:" + LAST_ASK_TIMESTAMP_COLUMN + "1", true /*hasHeaders*/);
  table.name = DATA_PRODUCER_TABLE_NAME;

  table.getHeaderRowRange().values = [
    [
      "ID",
      "ISIN",
      "Name",
      "Alias",
      "Bid",
      "Ask",
      "Quote Feed",
      "   ",
      "  ",
      "Last Bid Sent",
      "Last Bid Timestamp",
      "Last Ask Sent",
      "Last Ask Timestamp",
    ],
  ];

  const idxsToStyle = [ROW_ID_IDX, ISIN_IDX, NAME_IDX, ALIAS_IDX];

  idxsToStyle.forEach((idx) => {
    table.columns.getItemAt(idx).getRange().numberFormat = [["@"]];
    table.columns.getItemAt(idx).getRange().format.horizontalAlignment = Excel.HorizontalAlignment.left;
  });

  table.columns.getItemAt(QUOTE_FEED_IDX).getRange().format.horizontalAlignment = Excel.HorizontalAlignment.right;

  resetTableColors({ table, isDataProducer: true });

  table.getRange().format.autofitColumns();
  table.getRange().format.autofitRows();

  await protectDataProducerSheet({ worksheet: currentWorksheet });

  await context.sync();
}
